import moment from "moment";
import { useMemo } from "react";

export interface DropdownOption {
    value: string;
    label: string;
}

const allLabel = "Kaikki";

export const useDropdownOptions = <T>(
    data: T[],
    fieldSelector: (item: T) => string[],
    renderLabel?: (value: string) => string,
    sortComparator?: (a: string, b: string) => number
): DropdownOption[] =>
    useMemo(() => {
        const allValues = data.flatMap(fieldSelector).sort(sortComparator);
        const uniqueValues = [...new Set(allValues)];
        const dateValues = uniqueValues.every((value) =>
            moment(value, moment.ISO_8601, true).isValid()
        );

        return [
            { value: "", label: allLabel },
            ...uniqueValues.map((value) => {
                if (renderLabel) {
                    return {
                        value,
                        label: renderLabel(value),
                    };
                } else if (dateValues) {
                    return {
                        value,
                        label: moment(value).format("DD.MM.YYYY"),
                    };
                }

                return {
                    value,
                    label: value,
                };
            }),
        ];
    }, [data, fieldSelector, renderLabel, sortComparator]);
